import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output, DestroyRef, inject} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  Validators,
} from '@angular/forms';
import { EVENT_ID } from '@app/models/event.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { DynamicFormControlValidatorService } from '../../services/dynamic-form-control-validator.service';
import { MessagesService } from '../../pages/events-messages/services/messages.service';
import { CurrentDeviceService } from '@app/shared/services/current-device.service';

@Component({selector: 'app-modal-write-message',
  templateUrl: './modal-write-message.component.html',
  styleUrls: ['./modal-write-message.component.scss'],
  standalone: false,
})
export class ModalWriteMessageComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  @Input() visible: boolean = false;
  @Input() event_id: EVENT_ID;

  /** Send message to everyone option only */
  @Input() everyoneOptionOnly: boolean;

  /** Send message only for inside the event */
  @Input() sendToInsideEventOnly?: boolean;

  @Output() onSave = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  form: FormGroup;
  position = document.dir == 'rtl' ? 'left' : 'right';
  model: any = {};

  /** Default form state */
  defaultFormState: any = {};



  constructor(
    private fb: FormBuilder,
    private messageService: MessagesService,
    private formValidatorService: DynamicFormControlValidatorService,
    public currentDeviceService: CurrentDeviceService
  ) {
    this.formValidatorService.init(() => this.isNew);
  }

  ngOnInit(): void {
    this.onReady();
  }


  get isNew() {
    return Object.keys(this.model).length === 0;
  }

  onReady() {
    this.form = this.fb.group({
      event_id: [{ value: '', disabled: false }, []],
      display_type: [{ value: '', disabled: false }, []],
      body: [{ value: '', disabled: false }, [Validators.required]],
      subject: [{ value: '', disabled: false }, [Validators.required]],
      type: [{ value: 'ad', disabled: false }, [Validators.required]],
      action: [{ value: 'all', disabled: false }, [Validators.required]],
    });
    this.defaultFormState = this.form.value;
  }

  isRequired(key: string): boolean {
    const control: AbstractControl | null = this.form?.get(key);
    if (!control) {
      return false;
    }
    return !!(control.validator && !control.valid && !control.disabled);
  }

  reset() {
    this.form.reset();
  }

  open(model = {}) {
    this.model = model;
    this.formValidatorService.switchFormValidator();
    this.setDefaultValueToForm();

    /*     if(!this.isNew){
          this.form.disable();
        }
    
        if(!this.isNew && !this.form.touched){
        this,this.form.touched
        } */

    this.visible = true;
  }

  /**
   * Set default value to form
   */
  setDefaultValueToForm() {
    if (!this.isNew) {
      for (const key in this.model) {
        if (this.form.contains(key)) {
          const model = this.model as any;
          this.form.get(key)?.setValue(model[key]);
        }
      }
    }
  }

  cancel() {
    this.form.reset(this.defaultFormState);
    this.close();
  }

  close() {
    this.visible = !this.visible;
    this.onClose.emit(true);
  }

  onHide() {
    if (this.visible) {
      this.cancel();
    }
  }

  save() {
    this.form.disable();
    this.form.get('event_id')!.setValue(this.event_id);
    this.form.get('display_type')!.setValue('push');

    if (this.sendToInsideEventOnly) {
      this.form.get('action')!.setValue('inside');
    }

    this.messageService
      .createNew(this.form.value)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        this.form.enable();

        if (data.success) {
          this.onSave.emit();
          this.cancel();
        }
      });
  }
}
